import React, { useState } from 'react';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import ConversationTemp from 'component/organism/conversation/ConversationTemp';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';
import RoundedTabs from 'component/atom/Tabs/RoundedTabs';
import { useUserContext } from 'app-context/user/UserContext';
import Select from 'component/atom/forms/select/select/Select';
import styles from './Conversations.module.scss';

const Conversations = () => {
  const [isRefetch, setIsRefetch] = useState(null);
  const [isTryMe, setIsTryMe] = useState(0);
  const { showModal } = useTour();
  const { selectedBot } = useUserContext();
  const [botType, setBotType] = useState(selectedBot?.botType === 0 ? 2 : 0);

  const botTypeOptions =
    selectedBot?.botType === 1
      ? [
          { value: 0, label: 'External Chatbot' },
          { value: 2, label: 'Chat Interface' },
          { value: 1, label: 'Try Me Bot' },
        ]
      : [
          { value: 2, label: 'Chat Interface' },
          { value: 1, label: 'Try Me Bot' },
        ];

  const tabs = [
    {
      label: 'Bot',
    },
    {
      label: 'Try Me',
    },
  ];

  const rightItem = (
    <div>
      <Select
        placeholder='Type'
        selectClassname={styles['select-type']}
        classname={styles['select-container']}
        inputClassName={styles['select-input']}
        value={botType}
        onChange={(e) => setBotType(e.target.value)}
        options={botTypeOptions}
      />
      {/* <RoundedTabs tabs={tabs} activeTab={isTryMe} setActiveTab={setIsTryMe} /> */}
    </div>
  );
  return (
    <>
      <SettingsHeader title='Conversations' rightItem={rightItem} />
      <ConversationTemp isRefetch={isRefetch} botType={botType} />
      {showModal && <TourModal />}
    </>
  );
};

export default Conversations;
